import React from "react";
import {Card, SimpleCardHeading} from "peggirkit";
import CardHeader from "peggirkit/dist/components/Card/CardHeading/CardHeader";
import {JobApplicationDetails} from "@/data/entities/jobApplication";
import {FormattedMessage} from "react-intl";
import JobApplicationActions from "./actions/JobApplicationActions";
import PersonalDetails from "./PersonalDetails";
import GeneralDetails from "./GeneralDetails";
import {UpdateJobApplicationControlProps} from "../JobApplicationEditor";

type Props = UpdateJobApplicationControlProps & {
    jobApplication: JobApplicationDetails | undefined,
};

const DetailsSection = ({jobApplication, ...updateFormProps}: Props) => {

    return (
        <div className={"w-full flex flex-col items-start justify-start gap-6"}>
            <JobApplicationActions
                jobApplication={jobApplication}
                {...updateFormProps}
            />

            <Card
                containerClassname={"w-full"}
                header={
                    <CardHeader>
                        <SimpleCardHeading
                            title={<FormattedMessage id={"jobApplicationForm"}/>}
                        />
                    </CardHeader>
                }
            >
                <GeneralDetails jobApplication={jobApplication}/>
                <PersonalDetails jobApplication={jobApplication}/>
            </Card>
        </div>
    );
};

export default DetailsSection;
